import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import { TableCell, TableRow, Collapse } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

import { _parsePhoneNumber } from "../../../partials/validateNumber";
import TableFormat from "../../../partials/TableFormat";
import Dialog from "../../dialog";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import EditBranch from "./editBranch";
import crown from "../../../images/crown.svg";
import { styles } from "./styles";

const headCells = [
  { key: "isMain", numeric: false, disablePadding: true, label: "" },
  {
    key: "name",
    numeric: false,
    disablePadding: true,
    label: "servicebranch_tablehead_branch_name",
  },
  {
    key: "address",
    numeric: false,
    disablePadding: false,
    label: "servicebranch_tablehead_address",
  },
  {
    key: "mobile",
    numeric: false,
    disablePadding: false,
    label: "servicebranch_tablehead_mobile",
  },
  {
    key: "phone",
    numeric: false,
    disablePadding: false,
    label: "servicebranch_tablehead_phone",
  },
];

class listBranch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      branchToUpdate: {},
      dialog: {
        messageConfirm: "",
        content: "",
      },
      order: "asc",
      orderBy: "no",
      selected: [],
      collapse: [],
    };

    this.mTable = React.createRef({});

    this.handleSubmitUpdate = this.handleSubmitUpdate.bind(this);
    this.handleSubmitDelete = this.handleSubmitDelete.bind(this);
    this.handleOpenCollapes = this.handleOpenCollapes.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this);
  }
  openDialog = (messageConfirm, content, branchToUpdate) => {
    this.setState(
      {
        dialog: {
          messageConfirm: messageConfirm,
          content: content,
        },
        branchToUpdate: branchToUpdate,
      },
      function () {
        this.mDialog.handleDialogOpen();
      }
    );
  };

  handleOpenSnackBar = (message, type) => {
    this.mSnackbar.handleClick(message, type);
  };

  actionDialog = () => {
    let { t } = this.props;
    if (this.state.dialog.messageConfirm === t("servicebranch_delete")) {
      this.handleSubmitDelete();
    } else if (this.state.dialog.messageConfirm === t("servicebranch_update")) {
      this.handleSubmitUpdate();
    }
  };
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.adminService !== this.props.adminService ||
      (nextProps.adminService &&
        this.props.adminService &&
        nextProps.adminService.no !== this.props.adminService.no)
    ) {
      this.getBranchForOwner({
        serviceCode: nextProps.adminService.no,
      });
    }
  }
  getBranchForOwner = async (payload = {}) => {
    let { adminService = {}, role = "" } = this.props;
    if (
      (role !== "admin" && role !== "employeeAdmin") ||
      (adminService && adminService.no) ||
      (payload.serviceCode && this.mTable && this.mTable.state)
    ) {
      const { rowsPerPage, page, search } = this.mTable.state;
      this.loading.startLoading();
      if (!payload.serviceCode) {
        payload.serviceCode = adminService.no;
      }
      let check = await this.props.getBranchForOwner({
        limit: rowsPerPage,
        page: page,
        search: search,
        ...payload,
      });
      this.loading.stopLoading();
      if (check.code !== 1) {
        this.mSnackbar.handleClick(check.message, "error");
      }
    }
  };
  async handleSubmitUpdate(data) {
    let { t } = this.props;

    this.loading.startLoading();
    let check = await this.props.updateBranchForOwner({
      data: data,
    });
    this.loading.stopLoading();
    this.mDialog.handleDialogClose();
    if (check.code === 1) {
      this.getBranchForOwner();
      this.handleOpenCollapes(-1);
      this.mSnackbar.handleClick(t("servicebranch_update_successfully"));
    } else {
      this.mSnackbar.handleClick(
        t("servicebranch_update_unsuccessfully") + " " + check.message,
        "error"
      );
    }
  }

  async handleSubmitDelete(selected = []) {
    let { t } = this.props;
    if (selected && selected.length) {
      let check = await this.props.deleteBranchForOwner({
        listBranchDelete: selected,
      });
      if (check.code === 1) {
        this.mSnackbar.handleClick(t("servicebranch_delete_successfully"));
        return true;
      } else {
        this.mSnackbar.handleClick(
          t("servicebranch_delete_unsuccessfully") + " " + check.message,
          "error"
        );
        return false;
      }
    } else {
      this.mSnackbar.handleClick(t("pls_select_item"));
      return false;
    }
  }
  finishUpdateImageGallery = () => {
    this.getBranchForOwner();
  };
  isSelected = (id) => this.state.selected.indexOf(id) !== -1;
  handleOpenCollapes(id) {
    const serviceBranch = this.props.serviceBranch;
    const collapse = this.state.collapse;
    for (let i = 0; i <= serviceBranch.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else collapse[i] = false;
    }
    this.setState(collapse);
  }
  handleUpdate = (data) => {
    const { t } = this.props;
    this.openDialog(
      t("servicebranch_update"),
      t("servicebranch_are_you_sure_that_you_want_to_update_this_branch"),
      data
    );
  };
  renderCollapse = (row, index) => {
    const { collapse = [] } = this.state;
    const { serviceBranch = [], classes } = this.props;

    return (
      <TableRow key={index}>
        <TableCell
          colSpan={headCells.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditBranch
              district={this.props.district}
              item={index}
              handleOpenSnackBar={this.handleOpenSnackBar}
              finishUpdateImageGallery={this.finishUpdateImageGallery}
              branch={serviceBranch.find((e) => e.branchCode === row.id)}
              handleSubmitUpdate={this.handleSubmitUpdate}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  render() {
    const { t, total, count, serviceBranch = [], classes } = this.props;
    const { collapse = [] } = this.state;
    return (
      <>
        <Dialog
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("servicebranch_cancel")}
          agree={this.state.dialog.messageConfirm}
          title={t("servicebranch_notice")}
          content={t(this.state.dialog.content)}
          action={this.actionDialog}
        />
        <Loading onRef={(ref) => (this.loading = ref)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy="name"
          contentDialog={t("are_you_sure_that_you_want_to_delete_this_branch")}
          onDelete={this.handleSubmitDelete}
          title={t("sidebar_branch")}
          showFilter={false}
          placeholder={t("servicebranch_search_code_name_address")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getBranchForOwner}
          rows={serviceBranch.map((row) => {
            return {
              id: row.branchCode,
              name: row.branchName,
              address: row.address,
              mobile: _parsePhoneNumber(row.countryCode, row.mobile)
                .format_internal,
              phone: row.phone,
              isMain:
                row.isMain == 1 ? (
                  <div className={classes.crownImageContainer}>
                    <img src={crown} className={classes.crownImage} />
                  </div>
                ) : (
                  ""
                ),
            };
          })}
        />
      </>
    );
  }
}

listBranch.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  total: state.serviceBranch.total,
  count: state.serviceBranch.count,
  serviceBranch: state.serviceBranch.serviceBranch,
});

const mapDispatch = (dispatch) => ({
  deleteBranchForOwner: dispatch.serviceBranch.deleteBranchForOwner,
  getBranchForOwner: dispatch.serviceBranch.getBranchForOwner,
  updateBranchForOwner: dispatch.serviceBranch.updateBranchForOwner,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(listBranch)));
